// Handle Bynder download links
// Bynder's download endpoint returns JSON with s3_file URL
// This script intercepts Bynder download links and downloads from the actual S3 URL

console.log('dam_downloads.js loaded');

function handleBynderDownloads() {
  console.log('handleBynderDownloads called');

  // Find all links marked with data-bynder-download attribute
  const bynderLinks = document.querySelectorAll('a[data-bynder-download="true"]');

  console.log(`Found ${bynderLinks.length} Bynder download links`);

  bynderLinks.forEach((link, index) => {
    console.log(`Setting up listener for link ${index + 1}:`, link.href);

    // Remove any existing listeners to avoid duplicates
    const newLink = link.cloneNode(true);
    link.parentNode.replaceChild(newLink, link);

    newLink.addEventListener('click', async function(e) {
      e.preventDefault();
      e.stopPropagation();

      const bynderUrl = this.href;
      console.log('Clicked Bynder download link:', bynderUrl);

      try {
        // Extract asset ID from Bynder URL
        // URL format: https://assets.razor.com/api/v4/media/{ASSET_ID}/download/
        const assetIdMatch = bynderUrl.match(/\/media\/([^\/]+)\//);
        if (!assetIdMatch) {
          throw new Error('Could not extract asset ID from URL');
        }
        const assetId = assetIdMatch[1];
        console.log('Asset ID:', assetId);

        // Call our Rails proxy endpoint instead of Bynder directly
        const proxyUrl = `/bynder_proxy/download/${assetId}`;
        console.log('Fetching from proxy:', proxyUrl);

        const response = await fetch(proxyUrl, {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        console.log('Response status:', response.status);

        if (!response.ok) {
          const errorData = await response.json();
          console.error('Error response:', errorData);
          throw new Error(errorData.error || `HTTP ${response.status}`);
        }

        const data = await response.json();
        console.log('Proxy response:', data);

        if (data.s3_file) {
          console.log('Redirecting to S3 URL:', data.s3_file);

          // Redirect to S3 URL to trigger download
          window.location.href = data.s3_file;
        } else {
          console.error('No s3_file in response. Full response:', data);
          alert('Download failed: No s3_file URL in response');
        }
      } catch (error) {
        console.error('Error during Bynder download:', error);
        alert(`Download failed: ${error.message}`);
      }
    });
  });
}

// Run on initial page load
document.addEventListener('DOMContentLoaded', handleBynderDownloads);

// Re-run on Turbolinks navigation
document.addEventListener('turbolinks:load', handleBynderDownloads);
